export default [{
  component: 'RemoteSupport_DetailsTab',
  roles: ['ADMIN', 'SUPER_ADMIN', 'SUPERVISOR', 'SERVICE', 'CLIENT', 'SUSTAINABILITY_MANAGER'],
  label: 'pages.repair.tabs.details',
  statuses: ['INITIAL'],
  state: 'DISABLED'
}, {
  component: 'RemoteSupport_ServiceReviewTab',
  roles: ['ADMIN', 'SUPER_ADMIN', 'SUPERVISOR', 'SERVICE', 'CLIENT', 'SUSTAINABILITY_MANAGER'],
  label: 'pages.remoteSupport.tabs.serviceReview',
  statuses: ['SERVICE_REVIEW'],
  state: 'DISABLED'
}, {
  component: 'RemoteSupport_WaitingCompletionTab',
  label: 'pages.repair.tabs.completed',
  state: 'DISABLED',
  items: [
    {
      roles: ['ADMIN', 'SUPER_ADMIN', 'SUPERVISOR', 'SERVICE', "SUSTAINABILITY_MANAGER"],
      statuses: ['WAITING_COMPLETION'],
    }, {
      roles: ['CLIENT'],
      statuses: ['WAITING_COMPLETION', 'DONE', 'REJECTED'],
    }
  ]
}, {
  component: 'RemoteSupport_HistoryTab',
  roles: ['ADMIN', 'SUPER_ADMIN', 'SUPERVISOR', 'SERVICE', "SUSTAINABILITY_MANAGER"],
  label: 'pages.repair.tabs.history', 
  statuses: ['DONE', 'REJECTED'],
  state: 'ENABLED-UNCHANGABLE'
}]